export function setCookie(name, value, days = 180) {
    if (typeof document === "undefined") return;

    const maxAge = days * 24 * 60 * 60;

    const isBrowser = typeof window !== "undefined";
    const hostname = isBrowser ? window.location.hostname : "";
    const isLocalhost =
        hostname === "localhost" ||
        hostname === "127.0.0.1" ||
        hostname === "[::1]";

    let cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;

    // ✅ Only set Domain in production
    if (!isLocalhost) {
        cookie += `; Domain=.apispreadsheets.com`;
    }

    // ✅ Only set Secure when on HTTPS (localhost is usually http)
    if (isBrowser && window.location.protocol === "https:") {
        cookie += "; Secure";
    }

    document.cookie = cookie;
}
